import React from 'react'
import DetailCard from './DetailCard'
import DetailRows, { type LocationOption } from './DetailRows'
import ConsumerIcon from '@/assets/DetailsCards_icons/meter_consumer_info_icon.svg'
import { buildDetailCards, cardTitles } from '@/utils/consumerDetailCards'

interface PersonalInfoCardProps {
  data?: any
  isEditMode?: boolean
  editedData?: Record<string, any>
  onFieldChange?: (field: string, value: any) => void
  resourceHeaders?: Record<string, string>
  langKey?: string
  locations?: LocationOption[]
}

const PersonalInfoCard: React.FC<PersonalInfoCardProps> = ({
  data,
  isEditMode = false,
  editedData = {},
  onFieldChange,
  resourceHeaders = {},
  langKey = 'he',
  locations = [],
}) => (
  <DetailCard
    title={cardTitles(langKey).consumer}
    icon={
      <img
        src={ConsumerIcon}
        alt="consumer"
        style={{ width: 18, height: 18 }}
      />
    }
    fitContent
  >
    <DetailRows
      rows={buildDetailCards(data, resourceHeaders, langKey).consumer}
      data={data}
      isEditMode={isEditMode}
      editedData={editedData}
      onFieldChange={onFieldChange}
      locations={locations}
      emptyMessage={
        langKey === 'he' ? 'אין פרטי צרכן להצגה' : 'No consumer details'
      }
    />
  </DetailCard>
)

export default PersonalInfoCard
